function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { PrivacyCategory, isPrivacyCategoryEnabled } from "@lululemon/mwa-guest-integrity";
import { getDigitalOptimizationClientID, flagCache } from "./ld-cache";
import { handleCookies } from "./cookies";
var options = {
    path: "/",
    domain: ".lululemon.com"
};
export var GEO_COOKIES = {
    remove: [
        {
            name: "lll_adobe_geo_city",
            options: options
        },
        {
            name: "lll_adobe_geo_country",
            options: options
        },
        {
            name: "lll_adobe_geo_latitude",
            options: options
        },
        {
            name: "lll_adobe_geo_longitude",
            options: options
        },
        {
            name: "lll_adobe_geo_postal_zip",
            options: options
        },
        {
            name: "lll_adobe_geo_state",
            options: options
        },
        {
            name: "pers_seg",
            options: options
        }
    ]
};
export var isABTestingEnabled = /*#__PURE__*/ _async_to_generator(function() {
    var _flagCache_clientId, userLocale, _window___NEXT_DATA__, clientId, _ref, _ref_denyLocaleList, denyLocaleList, _denyLocaleList_locales, locales, functionalPrivacyCategoryEnabled, enableAbtesting;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                userLocale = "";
                if (typeof window !== "undefined") {
                    ;
                    userLocale = (_window___NEXT_DATA__ = window.__NEXT_DATA__) == null ? void 0 : _window___NEXT_DATA__.locale;
                }
                clientId = getDigitalOptimizationClientID();
                _ref = ((_flagCache_clientId = flagCache[clientId]) == null ? void 0 : _flagCache_clientId.flags) || {}, _ref_denyLocaleList = _ref.denyLocaleList, denyLocaleList = _ref_denyLocaleList === void 0 ? {} : _ref_denyLocaleList;
                _denyLocaleList_locales = denyLocaleList.locales, locales = _denyLocaleList_locales === void 0 ? [] : _denyLocaleList_locales;
                return [
                    4,
                    isPrivacyCategoryEnabled(PrivacyCategory.Functional)
                ];
            case 1:
                functionalPrivacyCategoryEnabled = _state.sent();
                enableAbtesting = !!functionalPrivacyCategoryEnabled && !locales.includes(userLocale);
                // remove the geo cookies from Adobe if exists from the previous load
                if (!enableAbtesting) {
                    handleCookies(GEO_COOKIES);
                }
                return [
                    2,
                    enableAbtesting
                ];
        }
    });
});

//# sourceMappingURL=disable-abtesting.js.map